/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockTenders
 * @description data access service for managing and reviewing tenders
 */
angular.module('mercury.modules.stock.tender')
.factory('StockTenders', ["$resource", "settings", function($resource, settings) {
  var StockTenders = $resource(settings.apiHost + '/r/StockTenders/:id', {id: '@id'}, {patch: {method: 'PATCH'}});

  /**
   * Get a summary all supplier tenders
   *
   * @memberof StockTenders
   */
  function getAll() {
    return StockTenders.query();
  }

  /**
   * get the full details of a specific tender
   *
   * @memberof StockTenders
   * @param  {String} id Id of the tender to get
   */
  function get(id) {
    return StockTenders.get({id: id});
  }

  /**
   * Create or update a specific tender
   *
   * @memberof StockTenders
   * @param  {Object} tender Model of the tender to create or update
   */
  function save(tender) {
    if (tender.id) {
      return StockTenders.update(tender).$promise;
    } else {
      return StockTenders.save(tender).$promise;
    }
  }

  /**
   * Set the specified tender as deleted
   *
   * @memberof StockTenders
   * @param  {Object} tender Model of the tender to delete
   */
  function remove(tender) {
    return StockTenders.patch({id: tender.id}, {datestampDeleted: moment().format()}).$promise;
  }

  /**
   * Review the specified supplier tender
   *
   * @memberof StockTenders
   * @param  {String} tenderId    Id of the tender to review
   * @param  {String} startTime   Start of time period to limit the review to: default tender start.
   * @param  {String} endTime     End of the time period to limit the review to: default tender end.
   * @param  {Boolean} creditNotes Should credit notes be included in the tender review: default true.
   */
  function review(tenderId, startTime, endTime, creditNotes) {
    return StockTenders.get({id: tenderId, startTime: startTime, endTime: endTime, includeCreditNotes: creditNotes});
  }

  return {
    getAll: getAll,
    get: get,
    save: save,
    review: review,
    remove: remove
  };
}]);
